import { render } from "./MySidebarTopBar.vue?vue&type=template&id=545b787c"
import script from "./MySidebarTopBar.vue?vue&type=script&lang=js"
export * from "./MySidebarTopBar.vue?vue&type=script&lang=js"

import exportComponent from "/home/fluffypony/Projects/cards/cards-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__